package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2024_03_08_Day_1
import com.veldekar.components.widgets.SessionDayHeader
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2024-03-08")
@Composable
public fun Log_2024_03_08(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Cark Liberated",
        ogTitle = "Cark Liberated",
        date = LocalDate(2_024, 3, 8),
        ogDescription = "The Malusian army and the heroes successfully liberate Cark, though a mysterious Slaad manages to escape.",
        ogImage = "ai/2024-03-08.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
    ) {
        SessionDayHeader(dayId = "newgrowth-46", dateString = "Newgrowth 46")
        Log_2024_03_08_Day_1()
    }
}
